// extracted by mini-css-extract-plugin
export var card = "_5y-0";
export var failedIcon = "_5y-4";
export var failedIconBadge = "_5y-3";
export var icon = "_5y-1";
export var successIcon = "_5y-2";